// removed by extract-text-webpack-plugin
module.exports = {"root":"category-nav__root","item":"category-nav__item","selectedItem":"category-nav__selectedItem","itemContent":"category-nav__itemContent"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/category-nav/styles.less
// module id = 74
// module chunks = 1 2